import api from "./core";

const basePath = "api/core/PortalDocuments";

export default {
  shareDocuments(data) {
    return api.post(`${basePath}/ShareDocument`, data);
  },
  shareForms(data) {
    return api.post(`${basePath}/ShareForms`, data);
  },
  sharePatientForms(data) {
    return api.post(`${basePath}/SharePatientForms`, data);
  },
  findAllSharedDocuments(eocId) {
    return api.get(`${basePath}/SharedDocuments/${eocId}`);
  },
  stopSharingDocument(sharedDocumentId) {
    return api.delete(`${basePath}/${sharedDocumentId}`);
  },
  shareRecurrentForm(data) {
    return api.put(`${basePath}/SharedRecurrentForms`, data);
  },
  findAllSharedRecurrentForms(eocId) {
    return api.get(`${basePath}/SharedRecurrentForms/${eocId}`);
  },
  stopSharingRecurrentForm(sharedRecurrentFormId) {
    return api.delete(
      `${basePath}/SharedRecurrentForms/${sharedRecurrentFormId}`
    );
  },
  shareDocumentPackage(data) {
    return api.post(`${basePath}/ShareDocumentPackage`, data);
  },
  massDocumentRequest(data) {
    return api.post(`${basePath}/MassDocumentRequest`, data);
  }
};
